import { useRouter } from 'vue-router';
import { usePush } from '../push/PushClient.ts';
import { useSessionStore } from '../stores/session.ts';
import { useInboxStore } from '../stores/inbox.ts';
import { useWorkspaceStore } from '../stores/workspace.ts';

/**
 * Signing out, everywhere it's offered: the server forgets this browser's push
 * device with the session (all devices when signing out everywhere), and the
 * browser stops push, so the next person here doesn't see someone else's work
 * in notifications.
 */
export function useSignOut() {
  const session = useSessionStore();
  const workspace = useWorkspaceStore();
  const inbox = useInboxStore();
  const push = usePush();
  const router = useRouter();

  return async function signOut({
    everywhere = false,
    then = 'login',
  }: { everywhere?: boolean; then?: 'login' | 'stay' } = {}): Promise<void> {
    const pushDevice = await push.currentHash().catch(() => null);
    await session.logout({ everywhere, pushDevice });
    await push.unsubscribe().catch(() => undefined);
    workspace.reset();
    inbox.reset();
    if (then === 'login') await router.replace({ name: 'login' });
  };
}
